import Button from '@klv/atoms/button';
import Eyebrow from '@klv/atoms/eyebrow';
import Icon from '@klv/atoms/icon';
import Typography from '@klv/atoms/typography';
import styled from 'styled-components';

export const StyledEyebrow = styled(Eyebrow)`
  font-size: 1.4rem;
  margin-bottom: .8rem;
`;

export const StyledIcon = styled(Icon)`
  margin-bottom: 2.4rem;
`;

export const BodyText = styled(Typography)`
  font-size: 1.8rem;
  margin-bottom: 2.4rem;
  line-height: 2.8rem;
`;

export const MoreLink = styled.a`
  text-decoration: none;
  z-index: 1;
  flex-basis: 0%;

  &::after {
    border-radius: .8rem;
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const ButtonContainer = styled.div`
  align-self: flex-start;
`;

export const StyledButton = styled(Button)`
  font-size: 2rem;
  line-height: 2.4rem;
  display: block;
  z-index: 2;
  position: relative;
  width: auto;
  bottom: 0;
`;

export const InnerCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
export const StyledMoreCard = styled.div<{ hasFormId: boolean; }>`
  width: 100%;
  max-width: 41rem;
  border: 1px solid ${({ theme }) => theme.moreCard.borderColor};
  border-radius: 1.4rem;
  grid-column: span 4;
  padding: 2.7rem 2.3rem;
  position: relative;
  transition: all 0.3s;

  ${({ theme, hasFormId }) => (hasFormId ? '' : `
    &:hover {
      box-shadow: 0 0 0 0.2rem ${theme.moreCard.borderColor}, 0 0.6rem 1.2rem 0 ${theme.moreCard.shadowColor};
  }`)}

  strong {
    font-weight: 500;
  }
`;

export const ContentContainer = styled.div``;
